const companyEnPages = {
  //select entity page
  selectEntityPage_Selling: 'Selling',
  selectEntityPage_Selling_Subtitle: 'Start selling smarter',
  selectEntityPage_Management: 'Management',
  selectEntityPage_Management_Subtitle: 'Start managing smoothly',
  selectEntityPage_Growing: 'Growing',
  selectEntityPage_Growing_Subtitle: 'Start growing quickly',
  // notifications page
  notificationsPage_title: 'Notifications',
  notificationsPage_Emails: 'Emails',
  notificationsPage_Sms: 'Sms',
  notificationsPage_Notifications: 'Notifications',
  notificationsPage_EmailSubject: 'Subject',
  notificationsPage_ToEmail: 'To email',
  notificationsPage_FromEmail: 'From email',
  notificationsPage_Error: 'Error',
  notificationsPage_SentOn: 'Sent on',
  notificationsPage_EmailContent: 'Email content',
  notificationsPage_PhoneNumber: 'Phone number',
  notificationsPage_CountryCode: 'Country code',
  notificationsPage_Message: 'Message',
  notificationsPage_SmsProvider: 'Sms provider',
  notificationsPage_SenderName: 'Sender name',
  notificationsPage_IsEnable: 'Is enabled',
  notificationsPage_ToUser: 'To user',
  // company settings page
  companySettingsPage_Title: 'Company settings',
  companySettingsPage_CompanyGeneralInfo: 'Company general info',
  companySettingsPage_General: 'General',
  companySettingsPage_CarrieCode: 'Carrier Code Display',
  companySettingsPage_DateFormat: 'Date Format',
  companySettingsPage_TimeFormat: 'Time Format',
  companySettingsPage_InsuranceExpirationDays: 'Insurance Expiration Days ',
  companySettingsPage_DistanceUnit: 'Distance Unit',
  companySettingsPage_WeightUnit: 'Weight Unit ',
  companySettingsPage_IntervalDays: 'Interval days',
  companySettingsPage_TripRangeValue: 'Trip range value ',
  companySettingsPage_OrangeBfuSerId: 'Orange BF Username',
  companySettingsPage_OrangeBfPassword: 'Orange BF password',
  companySettingsPage_SmsServiceUserName: 'SMS Service UserName',
  companySettingsPage_SmsServicePassword: 'SMS Service Password',
  companySettingsPage_ActionCasse: 'Register action',
  companySettingsPage_NbrVoyage: 'Free trip',
  companySettingsPage_TripSearchHoursGapSetup: 'Trip Search Hours Gap',
  companySettingsPage_TripSalesLimitTime: 'Trip Sales Limit Time',
  companySettingsPage_TripBoardingLimitTime: 'Trip Boarding Limit Time',
  companySettingsPage_CompanyLogoImage: 'Company logo',
  companySettingsPage_ShipmentNotificationAmount: 'Shipment Notification Amount',
  companySettingsPage_IsShipmentNotificationSenderEnabled: ' Send Shipment Notification to Sender',
  companySettingsPage_IsShipmentNotificationReceiverEnabled: ' Send Shipment Notification to Receiver',
  companySettingsPage_ValiditySettings: 'Validity Settings',
  companySettingsPage_TicketExpirationDays: 'Ticket Validity Days',
  companySettingsPage_BookPayLaterSettings: 'Book & Pay Later Settings',
  companySettingsPage_BookingAllowedTime: 'Booking Allowed Time',
  companySettingsPage_BookingConfirmationLimitTime: 'Booking Confirmation Limit Time',
  companySettingsPage_BookingReminderLimitTime: 'Booking Reminder Limit Time',
  companySettingsPage_OnDepartureTime: 'On Departure Time',
  companySettingsPage_OnBookingTime: 'On Booking Time',
  companySettingsPage_IsSeatReleasedOnDepartureTime: 'Seat Release Mechanism',
  companySettingsPage_SettingsCompanyDetails: 'Company settings detail',
  companySettingsPage_DefaultEmail: 'Default Email',
  companySettingsPage_NoCc: 'No CC',
  companySettingsPage_NoIfu: 'NoIFU',
  companySettingsPage_EmployerNo: 'Employer No',
  companySettingsPage_CompanyUrl: 'Company Url',
  companySettingsPage_TripFillUpThresholdValue: 'Trip Threshold Value',
  companySettingsPage_CompanyName: 'Company name',
  companySettingsPage_UpdateSuccess: 'Update successfull!',
  ShipmentInsuranceSettingType_FlatBase: 'Flat base',
  ShipmentInsuranceSettingType_PercentageBase: 'Percentage Base',
  ShipmentInsuranceSettingType_RangeBase: 'Range Base',
  companySettingsPage_ShipmentInsuranceSettings: 'Shipment Insurance Settings',
  companySettingsPage_ShipmentInsuranceSettingType: 'Insurance Settings',
  companySettingsPage_IsShipmentMinimumRangeValue: 'Apply Shipment Minimum Range Value',
  companySettingsPage_AddRariff: 'Add tariff',
  companySettingsPage_IsPercentageAmount: 'Is percentage amount',
  companySettingsPage_RangeValueCannotOverlapping: 'Range Values Cannot be Overlapping',
  companySettingsPage_FromLessThanTo: 'From should not be less than To.',
  PaymentPartnerNotAvailable: 'This operator or bank is not available for the company country.',
  companySettingsPage_AccountEntity: 'Account entity',
  companySettingsPage_OperatorBank: 'Operator / Bank',
  companySettingsPage_AccountOwner: 'Account owner',
  companySettingsPage_AccountNumber: 'Account number',
  companySettingsPage_AccountType: 'Account type',
  companySettingsPage_Accounts: 'Accounts',
  companySettingsPage_AccountNumberMustBeNumer: 'Account number only accepts numbers',
  companySettingsPage_AddAccount: 'Add account',
  companySettingsPage_UpdateAccount: 'Update account',
  companySettingsPage_Notifications: 'Notifcations',
  companySettingsPage_TicketSettings: 'Ticket settings',
  companySettingsPage_CompanyDisplayName: 'Company display name',
  companySettingsPage_CompanyAddress: 'Company address',
  companySettingsPage_CompanyLogoImageUrl: 'Company logo',
  companySettingsPage_CreateTicketSetting: 'Create ticket setting',
  companySettingsPage_UpdateTicketSetting: 'Update ticket setting',
  companySettingsPage_NotificationContacts: 'Notification Contacts',
  companySettingsPage_SMSServiceSetting: 'SMS Service Settings',
  companySettingsPage_ContactName: 'Contact Name',
  companySettingsPage_ContactPhoneNumber: 'Contact Phone Number',
  companySettingsPage_ServiceUrl: 'Service url',
  companySettingsPage_TicketModificationSetting: 'Ticket modification setting',
  companySettingsPage_TicketModificationLimitTime: 'Ticket modification limit time',
  companySettingsPage_SellOnTheGoSetting: 'Sell on the go setting',
  companySettingsPage_SellOnTheGoBaseTariff: 'Is segment base tariff',
  // Tariff Parameters
  companySettingsPage_TariffParamsSarchText: 'Tariff name, code...',
  companySettingsPage_TariffCategory: 'Tariff category',
  companySettingsPage_TariffParams_Name: 'Tariff name',
  companySettingsPage_CreateTariffParams: 'Create tariff parameters',
  companySettingsPage_UpdateTariffParams: 'Update tariff parameters',
  companySettingsPage_TariffParameters: 'Tariff Parameters',
  companySettingsPage_BaseTariffParameter: 'Base Tariff Parameters',
  // SellOnTheGoFareConfiguration
  companySettingsPage_SellOnTheGo: 'Sell on the go - fare configuration',
  companySettingsPage_SellOnTheGoFromKms: 'From kms',
  companySettingsPage_SellOnTheGoToKms: 'To kms',
  companySettingsPage_SellOnTheGoTariffValue: 'Tariff value',
  companySettingsPage_SellOnTheGoIsInRate: 'Is in rate',
  companySettingsPage_AddFareConfigurations: 'Add fare configuration',
  companySettingsPage_UpdateFareConfigurations: 'Update fare configuration',
  companySettingsPage_SellOnTheGoFromKmsLessThanToKms: 'From kms must be less than To kms',
  // Subscriptions page
  subscriptionsPage_Title: 'Subscriptions',
  subscriptionsPage_PlanFeature: 'Plan Feature',
  subscriptionsPage_Registers: 'Registers',
  subscriptionsPage_PaymentMethod: 'Payment Method',
  subscriptionsPage_PerMonth: 'Per Month',
  subscriptionsPage_LearnMore: 'Learn more',
  subscriptionsPage_Subscribe: 'Subscribe',
  subscriptionsPage_NotAvailable: 'Not available',
  subscriptionsPage_PlanMonthlyFees: 'Plan Monthly Fees : ',
  subscriptionsPage_TotalAmount: 'Total Amount : ',
  subscriptionsPage_PlanComponentFees: 'Plan Component Fees : ',
  subscriptionsPage_SubscribeNow: ' Subscribe Now',
  subscriptionsPage_Note: 'Note',
  subscriptionsPage_NoteDetail: `Subscribing to new plan will result in loss of older plan validity and features. You will be charged XOF 0 on monthly
  basis for this subscription.`,
  subscriptionsPage_FreePlanNote:
    'This plan can not be subscribed as this is a free plan or number of registers in your current plan exceeds number of registers in this plan',
  subscriptionsPage_PlanExpiresOn: 'Plan Expires on : ',
  subscriptionsPage_NoData: 'No data',
  // stations page
  stationsPage_Title: 'Stations',
  stationsPage_AddStation: 'Add station',
  stationsPage_UpdateStation: 'Update station',
  stationsPage_StationName: 'Station name',
  stationsPage_StationCode: 'Station code',
  stationsPage_LatitudeLongitude: 'Latitude/Longitude',
  stationsPage_QuartierName: 'Quartier Name',
  stationsPage_CityRegionCountry: 'City-region-country',
  stationsPage_StationAdministrator: 'Station Administrator',
  stationsPage_StationSupervisor: 'Station Supervisor',
  stationsPage_StartingBalance: 'Starting Balance',
  stationsPage_Latitude: 'Latitude',
  stationsPage_Longitude: 'Longitude ',
  stationsPage_Quartier: 'District',
  stationsPage_ExpenseArpprover: 'Expense approver',
  stationsPage_IsConnectionStation: 'Is Connection Station',
  stationsPage_StationImageUrl: 'Station Image',
  stationsPage_displayPhoneNumbers: 'Display Phone Number',
  stationsPage_IsGlobalStation: 'Is Global Station',
  // station printer
  stationsPage_DeviceName: 'Device name',
  stationsPage_PrinterCompany: 'Printer company',
  stationsPage_PrintType: 'Print type',
  stationsPage_PrinterConfigurations: 'Printer configurations',
  stationsPage_AddPrinter: 'Add printer',
  stationsPage_UpdatePrinter: 'Update printer',
  // station Balance
  stationsPage_CurrentBalance: 'Current balance',
  stationsPage_ManageBalance: 'Manage balance',
  stationsPage_StationBalance: 'Station balance',
  stationsPage_StationBalanceEntityType: 'Entity type',
  stationsPage_StationBalanceEvent: 'Event',
  stationsPage_StationBalanceStationAction: 'Station action',
  stationsPage_StationBalanceAmount: 'Amount involved',
  stationsPage_StationBalanceDocuments: 'Documents',
  // staffs page
  staffsPage_Title: 'Staff',
  staffsPage_AddStaff: 'Add staff',
  staffsPage_UpdateStaff: 'Update staff',
  staffsPage_EmployeeId: 'Employee Id',
  staffsPage_EmployeeCode: 'Employee Code',
  staffsPage_EmployeeCategory: 'Employee category',
  staffsPage_JobTitle: 'Job title',
  staffsPage_Roles: 'Roles',
  staffsPage_Stations: 'Assigned stations',
  staffsPage_OtherLinks: 'Other assignments',
  staffsPage_OtherLinksNone: 'None',
  staffsPage_Link_Register: 'Register {{register}}',
  'staffsPage_Link_Station Administrator': 'Administrator',
  'staffsPage_Link_Station Supervisor': 'Supervisor',
  staffsPage_Link_Treasurer: 'Treasurer',
  staffsPage_Link_Cashier: 'Cashier',
  staffsPage_CanLogin: 'Can login',
  staffsPage_SearchText: 'Staff name, email....',
  staffsPage_JoiningDate: 'Joining Date',
  staffsPage_IgrParts: 'IGR Parts',
  staffsPage_ContractType: 'Contract type',
  staffsPage_Seniority: 'Seniority',
  staffsPage_CnpsId: 'CNPS ID',
  staffsPage_Employment: 'Employment',
  staffsPage_SalaryCategory: 'Salary Category',
  staffsPage_Qualification: 'Qualification',
  staffsPage_StaffImage: 'Staff image',
  staffsPage_PaymentMethod: 'Payment Method ',
  staffsPage_Cash: 'Cash',
  staffsPage_CashPaymentPortion: 'Cash Payment Portion (%)',
  staffsPage_MMAccountNumber: 'Mobile Money Account Number',
  staffsPage_AccountNumber: 'Account number',
  staffsPage_MobilePaymentPortion: 'Mobile Payment Portion (%)',
  staffsPage_BankAccountNumber: 'Bank Account Number',
  staffsPage_BankAccountPortion: 'Bank Payment Portion (%)',
  staffsPage_EmployeeType: 'Employee type',
  staffsPage_ExportStaffs: 'Export staffs',
  // ticket class page
  ticketClassesPage_Title: 'Ticket classes',
  ticketClassesPage_BaseTicketClassName: 'Base ticket class name',
  ticketClassesPage_Name: 'Name',
  ticketClassesPage_SeatColor: 'Seat color',
  ticketClassesPage_CreateTicketClass: 'Create ticket class',
  ticketClassesPage_UpdateTicketClass: 'Update ticket class',
  // seat model page
  seatModelsPage_Title: 'Seat models',
  seatModelsPage_SeatingModelName: 'Name',
  seatModelsPage_SeatingModelRef: 'Seating model ref',
  seatModelsPage_NoOfRows: 'No of rows',
  seatModelsPage_SeatingType: 'Type',
  seatModelsPage_CreateSeatModel: 'Create seat model',
  seatModelsPage_UpdateSeatModel: 'Update seat model',
  seatModelsPage_SeatInfo: 'Seat info',
  seatModelsPage_TicketClass: 'Ticket Class',
  seatModelsPage_SeatName: 'Seat name',
  seatModelsPage_RemoveSeat: 'Remove seat',
  seatModelsPage_Save: 'Save',
  seatModelsPage_BusBasicInfo: 'Bus basic info',
  seatModelsPage_BusDesign: 'Bus design',
  seatModelsPage_BusSummary: 'Summary',
  seatModelsPage_AddSeats: 'Add seats',
  // bus model page
  busModelsPage_Title: 'Bus models',
  busModelsPage_BusModelName: 'Model name',
  busModelsPage_BusBrandName: 'Brand name',
  busModelsPage_ModelPower: 'Model power',
  busModelsPage_modelYear: 'Model year',
  busModelsPage_CreateBusModel: 'Create bus models',
  busModelsPage_UpdateBusModel: 'Update bus models',
  // buses page
  busesPage_Title: 'Buses',
  busesPage_BusName: 'Bus Name',
  busesPage_SerialNo: 'Serial Number',
  busesPage_ChassisNo: 'Chassis Number',
  busesPage_MotorPower: 'Motor Power',
  busesPage_AcquisitionDate: 'Acquisition Date',
  busesPage_BaggageCapacity: 'Baggage Capacity',
  busesPage_InitialColor: 'Initial color',
  busesPage_PlateNumber: 'Plate Number',
  busesPage_transportVendor: 'Transport Vendor',
  busesPage_PurchaseOrderDetail: 'PO Ref No.',
  busesPage_SeatingModel: 'Seating model',
  busesPage_BusModel: 'Bus model',
  busesPage_BusBrand: 'Bus brand',
  busesPage_CreateBus: 'Create bus',
  busesPage_UpdateBus: 'Update bus',
  busesPage_OtherDetail: 'Other details',
  busesPage_SeatingDetail: 'Seating detail',
  busesPage_Summary: 'Summary',
  busesPage_VendorDetail: 'Vendor detail',
  busesPage_StaffList: 'Staff list',
  busesPage_BusMode: 'Bus mode',
  busesPage_UploadDocuments: 'Upload documents',
  busesPage_DocumentName: 'Document name',
  busesPage_FileName: 'File name',
  busesPage_Documents: 'Documents',
  busesPage_Upload: 'Upload',
  busesPage_SelectFile: 'Select file',
  busesPage_StartDate: 'Start date',
  busesPage_ExpirationDate: 'Expiration date',
  busesPage_BusInsurances: 'Bus Insurances',
  busesPage_AddBisInsurancePolicy: 'Add new insurance policy',
  busesPage_InsuranceDetail: 'Insurance detail',
  busesPage_PolicyNumber: 'Policy number',
  // Bus station mappings
  busStationMappingsPage_Title: 'Asign bus to stations',
  busStationMappingsPage_Bus: 'Bus',
  busStationMappingsPage_Station: 'Station',
  busStationMappingsPage_StartDate: 'Start date',
  busStationMappingsPage_EndDate: 'End date',
  busStationMappingsPage_CreateBusStationMapping: 'Asign bus to stations',
  busStationMappingsPage_UpdateBusStationMapping: 'Update bus station mapping',
  // sms template page
  smsTemplatesPage_Title: 'Sms templates',
  smsTemplatesPage_Name: 'Name',
  smsTemplatesPage_CultureCode: 'Culture Code',
  smsTemplatesPage_Content: 'Content',
  smsTemplatesPage_CreatTemplate: 'Create sms template',
  smsTemplatesPage_UpdateTemplaet: 'Update sms template',
  // passenger page
  passengersPage_Title: 'Passengers',
  passengersPage_IsTicketBookingAllowed: 'Booking allowed',
  passengersPage_SearchText: 'Passenger name, emaill, phone...',
  passengersPage_PassengerType: 'Passenger type',
  passengersPage_CreatePassenger: 'Create passenger',
  passengersPage_UpdatePassenger: 'Update passenger',
  passenger_UpdateAppliesToNextTrips: "The correction applies to upcoming trips. Tickets already issued keep their identity: to correct a ticket, modify the ticket from the cashier app.",
  ticketHolder_Differs: "The ticket identity differs from the passenger record",
  ticketHolder_Ticket: "Ticket (identity frozen at sale)",
  ticketHolder_Record: "Record",
  passengerHistory_Title: "Record history",
  passengerHistory_Empty: "No correction",
  passengerHistory_Date: "Date",
  passengerHistory_Source: "Origin",
  passengerHistory_Field: "Field",
  passengerHistory_Old: "Before",
  passengerHistory_New: "After",
  passengerHistory_By: "By",
  passengerHistory_Source_CounterSale: "Counter sale (confirmed)",
  passengerHistory_Source_BackOffice: "Back office",
  passengerHistory_Source_CompanyCopy: "Company copy",
  passengerHistory_Field_FirstName: "First name",
  passengerHistory_Field_LastName: "Last name",
  passengerHistory_Field_DateOfBirth: "Date of birth",
  GenderType_Male: "Male",
  GenderType_Female: "Female",
  passengerHistory_Field_Gender: "Gender",
  passengerHistory_Field_Phone: "Phone",
  passengerHistory_Field_EmailAddress: "E-mail",
  passengerHistory_Field_Copy: "Copy of the shared record",
  invalidPhones_Button: "Invalid numbers",
  invalidPhones_Title: "Records with an invalid number",
  invalidPhones_Description: "These passengers have an incomplete or invalid number: the counter search cannot find them. Enter the full number; it is saved in international format and the correction appears in the record history.",
  invalidPhones_Empty: "No record with an invalid number",
  invalidPhones_Passenger: "Passenger",
  invalidPhones_Current: "Saved number",
  invalidPhones_LastTravel: "Last trip",
  invalidPhones_Correction: "Corrected number",
  invalidPhones_NewNumber: "Full number",
  invalidPhones_Corrected: "Number corrected.",
  PassengerPhoneInvalid: "Incomplete or invalid number: enter the full number.",
  withoutPhone_Button: "Sales without phone",
  withoutPhone_Title: "\"Without phone\" sales by cashier",
  withoutPhone_Description: "Tickets sold with the \"Without phone\" button, over the last 30 days.",
  withoutPhone_Empty: "No sale without phone",
  withoutPhone_Cashier: "Cashier",
  withoutPhone_Tickets: "Tickets",
  withoutPhone_LastSale: "Last sale",
  // routes page
  routesPage_Title: 'Routes',
  routesPage_Station: 'Station',
  routesPage_RouteName: 'Route name',
  routesPage_RouteInternalCode: 'Route internal code',
  routesPage_RouteType: 'Route type',
  routesPage_Origin: 'Origin',
  routesPage_Destination: 'Destination',
  routesPage_Distance: 'Distance (km)',
  routesPage_Stops: 'Stops',
  routesPage_SearchText: 'Route name, code...',
  routesPage_CreateRoute: 'Create route',
  routesPage_UpdateRoute: 'Update route',
  routesPage_IsRoundTrip: 'Is round trip',
  routesPage_OriginCountry: 'Origin country',
  routesPage_OriginStation: 'Origin station',
  routesPage_DestinationCountry: 'Destination country',
  routesPage_DestinationStation: 'Destination station',
  routesPage_StopName: 'Stop name',
  routesPage_DistanceFromSource: 'Distance from Source',
  routesPage_AddStop: 'Add stop',
  routesPage_ManageStops: 'Manage stops',
  routesPage_RouteStops: 'Route stops',
  // Baggage Tariffs Page
  baggageTariffsPage_Title: 'Baggage tariffs',
  baggageTariffsPage_UpdateBaggageTariffs: 'Update baggage tariffs',
  baggageTariffsPage_From: 'From',
  baggageTariffsPage_To: 'To',
  baggageTariffsPage_FreeBag: 'Free bag',
  baggageTariffsPage_MaxBag: 'Max bag',
  baggageTariffsPage_SecondTariff: 'Tarrif Bagage 2',
  baggageTariffsPage_TarrifBagageMoto: 'Tarrif Bagage Moto',
  baggageTariffsPage_TicketClass: 'Ticket class',
  baggageTariffsPage_TarrifBagage: 'Tarrif Bagage',
  baggageTariffsPage_SearchText: 'Station from, to...',
  baggageTariffsPage_CreateNewSegment: 'Create segment',
  baggageTariffsPage_SelectRoute: 'Route',
  // ticket tariff page
  ticketTariffsPage_Title: 'Ticket tariffs',
  ticketTariffsPage_BaseRate: 'Base rate',
  ticketTariffsPage_BaseRateReturn: 'Base rate return',
  ticketTariffsPage_Distance: 'Distance',
  baggageTariffsPage_UpdateTicketTariffs: 'Update ticket tariffs',
  ticketTariffsPage_Segment_Tariff: 'Tariff',
  ticketTariffsPage_Segment_Category: 'Category',
  ticketTariffsPage_Segment_Code: 'Code',
  ticketTariffsPage_Segment_Name: 'Name',
  ticketTariffsPage_Segment_ValueType: 'Value type',
  ticketTariffsPage_Segment_Value: 'Value',
  ticketTariffsPage_Segment_ReturnValue: 'Return value',
  ticketTariffsPage_Segment_Direction: 'Direction',
  ticketTariffsPage_Segment_SearchText: 'Category, code, name...',
  ticketTariffsPage_Segment_UpdateTariffParameter: 'Update Tariff Parameter',
  ticketTariffsPage_Segment_ApplyForAllSegments: 'Apply for all segments',
  ticketTariffsPage_Segment_ApplyForAllSegmentsConfirm: 'Are you sure want to apply this tariff for all segment?',
  // trips page
  tripsPage_Title: 'Trips',
  tripsPage_Route: 'Route',
  tripsPage_SearchText: 'Trip name...',
  tripsPage_DepartureDate: 'Departure Date',
  tripsPage_TripName: 'Trip name',
  tripsPage_Source: 'Source station',
  tripsPage_DepartureDateTime: 'Departure date time',
  tripsPage_Destination: 'Destination station',
  tripsPage_ArrivalDateTime: 'Arrival date time',
  tripsPage_Duration: 'Duration (hh:mm)',
  tripsPage_NoOfStops: 'No Of Stops',
  tripsPage_CreateTrip: 'Create trip',
  tripsPage_UpdateTrip: 'Update trip',
  tripsPage_IsRecurred: 'Is Recurred',
  tripsPage_TripGroups: 'Trip groups',
  tripsPage_TripGroupName: 'Group name',
  tripsPage_CreateTripGroup: 'Create trip group',
  tripsPage_TripDetail: 'Trip detail',
  tripsPage_SeatingModel: 'Seating model',
  tripsPage_Group: 'Group',
  tripsPage_RouteTripDetail: 'Route trip detail',
  tripsPage_ConnectionPoint: 'Connection Point',
  tripsPage_WantToRecurTrip: 'Do you want to Recur this Trip? ',
  tripsPage_RecurTripNote: `
                      <b>1</b>. Please Consider Dates of Maintenance Plans to avoid any overlapping/mixup for recurrence.<br/>
                      <b>2</b>. Please Delete the Overlapping Trips immediately after it is Auto Scheduled to avoid user selecting the trip for booking.`,
  tripsPage_TripRecurrenceDays: 'Trip Recurrence days: 30 Days',
  tripsPage_CopyTrip: 'Copy trip',
  tripsPage_ActiveOrInActive: 'Active/ In active trip',
  tripsPage_Map: 'Map',
  // Discount
  discountsPage_Title: 'Discounts',
  discountsPage_Name: 'Name',
  discountsPage_StartDate: 'Start date',
  discountsPage_EndDate: 'End date',
  discountsPage_Value: 'Value',
  discountsPage_ValueType: 'Value type',
  discountsPage_beneficiaryType: 'Beneficiary type',
  discountsPage_targetType: 'Target type',
  discountsPage_CreateDiscount: 'Create discount',
  discountsPage_UpdateDiscount: 'Update discount',
  discountsPage_Trip: 'Trip',
  discountsPage_Route: 'Route',
  discountsPage_Segment: 'Segment',
  discountsPage_TicketClass: 'Ticket class',
  discountsPage_TariffParameter: 'Tariff Parameter',
  discountsPage_Passengers: 'Passengers',
  //
  discountsPage_AllPassengers: 'All passengers',
  discountsPage_AllTicketClasses: 'All ticket classes',
  discountsPage_AllTariffParameters: 'All tariff Parameters',
  discountsPage_AllTrips: 'All trips',
  discountsPage_AllRoutes: 'All routes',
  discountsPage_AllSegments: 'All segments',
  // trip calendar
  tripsCalendarPage_Title: 'Trips calendar',
  tripsCalendarPage_Country: 'Country',
  tripsCalendarPage_Station: 'Station',
  tripsCalendarPage_TripName: 'Trip name',
  tripsCalendarPage_NumberOfPassenger: 'Number Of Passenger',
  tripsCalendarPage_Driver: 'Driver',
  tripsCalendarPage_CoDriver: 'Co Driver',
  tripsCalendarPage_BusName: 'Bus',
  tripsCalendarPage_BusPlate: 'Plate number',
  tripsCalendarPage_NoOfSeats: 'No. Assign Seats',
  tripsCalendarPage_NoOfConflictedBooking: 'No. Conflicted Booking',
  tripsCalendarPage_BusBrand: 'Bus brand',
  tripsCalendarPage_OnlyShowSameBusModel: 'Only show same bus models',
  tripsCalendarPage_IncludePassingStation: 'Include passing station',
  // trip details
  tripDetailsPage_Title: 'Trip details',
  tripDetailsPage_DepartureDate: 'Departure Date',
  tripDetailsPage_SourceStation: 'Source Station',
  tripDetailsPage_DestinationStation: 'Destination Station',
  tripDetailsPage_SeatingModel: 'Seating Model',
  tripDetailsPage_Route: 'Route',
  tripDetailsPage_Stops: 'Stops',
  tripDetailsPage_TripRefNumber: 'Ref Number',
  tripDetailsPage_SearchText: 'Trip name...',
  tripDetailsPage_TripName: 'Trip name',
  tripDetailsPage_SourceCountry: 'Source country',
  tripDetailsPage_DestinationCountry: 'Destination country',
  tripDetailsPage_ChangeStatus: 'Change status',
  tripDetailsPage_Status: 'Status',
  tripDetailsPage_CurrentStatus: 'Current station',
  tripDetailsPage_NextStation: 'Next station',
  tripDetailsPage_NewStatus: 'New status',
  tripDetailsPage_Remarks: 'Remarks',
  tripDetailsPage_DelayedTime: 'Delayed Time (Minutes)',
  tripDetailsPage_ActualTime: 'Actual time',
  tripDetailsPage_ExportPassenger: 'Export passengers',
  tripDetailsPage_ExportPassengerPdf: 'Export to PDF',
  tripDetailsPage_SendReportToEmail: 'Send report to email',
  //register page cashier
  registerPage_Title: 'Registers',
  registerPage_Name: 'Name',
  registerPage_StationName: 'Station',
  registerPage_RegisterStatus: 'Status',
  registerPage_Cashiers: 'Cashiers',
  registerPage_OpeningHours: 'Opening hours',
  registerPage_OpeningHoursFrom: 'Opening hours from',
  registerPage_OpeningHoursTo: 'Opening hours to',
  registerPage_StartingCash: 'Starting cash',
  registerPage_CurrentBalance: 'Current balance',
  registerPage_CreateRegister: 'Create register',
  registerPage_UpdateRegister: 'Update register',
  registerPage_ChangePin: 'Change pin',
  registerPage_NewPin: 'New pin',
  registerPage_PrintDestination: 'Print destination',
  registerPage_ReceiptDefaultPrinter: 'Receipt printer',
  registerPage_TicketDefaultPrinter: 'Ticket printer',
  registerPage_ShipmentLabelDefaultPrinter: 'Shipment label printer',
  registerPage_loyaltyClient: 'Loyalty client',
  registerPage_ActionAnnulation: 'Action annulation',
  registerPage_RegisterInfo: 'Register info',
  registerPage_ChangeToClose: 'Change status to Close',
  registerPage_ChangeToReady: 'Change status to Ready',
  registerPage_ResetPin: 'Reset pin',
  registerPage_ResetPinConfirm: 'Are you sure want to reset pin for this user?',
  registerPage_ResetPinSuccess: 'The new PIN has been sent to the user (SMS or e-mail)',
  registerPage_TicketPayments: 'Ticket payments',
  registerPage_PayMode: 'Pay mode',
  registerPage_CashierName: 'Cashier',
  registerPage_RechargeWithdraw: 'Register Recharge & Withdraw',
  registerPage_SelectAction: 'Select action',
  registerPage_AmountToTransfer: 'Amount to transfer',
  registerPage_ProcessAction: 'Process action',
  registerPage_GlobalRegisterTitle: 'Global Registers',

  // ticket booking
  ticketBooking_BookingRefNo: 'Booking Ref No',
  ticketBooking_TicketRefNo: 'Ticket Ref No',
  ticketBooking_Passenger: 'Passenger',
  ticketBooking_SeatNo: 'Seat No.',
  ticketBooking_BookingDate: 'Booking date',
  ticketBooking_TicketClassName: 'Ticket class',
  ticketBooking_FromStation: 'From station',
  ticketBooking_ToStation: 'To station',
  ticketBooking_FromCity: 'From city',
  ticketBooking_ToCity: 'To city',

  // manage tickets
  manageTicket_Title: 'Manage tickets',
  manageTicket_CancelTicket: 'Cancel ticket',
  manageTicket_UpdatePassenger: 'Update passenger',
  manageTicket_IsMainPassenger: 'Is main passenger',
  manageTicket_UpdatePassengerIdentity: 'Update passenger identity',
  manageTicket_UploadDocuments: 'Upload documents',
  // Register Reconciliation
  registerReconciliation_Title: 'Register Reconciliation',
  registerReconciliation_Cashier: 'Cashier',
  registerReconciliation_PaymentDate: 'Payment date',
  registerReconciliation_NoOfPassengers: 'No Of Passengers',
  registerReconciliation_OutStandingAmount: 'OutStandingAmount',
  registerReconciliation_CancelledAmount: 'CancelledAmount',
  registerReconciliation_CashierName: 'Cashier name',
  registerReconciliation_LastReconciliation: 'Last Reconciliation',
  registerReconciliation_SelectCashier: 'Select cashier',
  registerReconciliation_BookingTotalAmount: 'Booking Total Amount',
  registerReconciliation_ShipmentTotalAmount: 'Shipment Total Amount',
  registerReconciliation_ParkingTotalAmount: 'Parking Total Amount',
  registerReconciliation_ExpenseTotalAmount: 'Expense Total Amount',
  registerReconciliation_IsAmountVerified: 'Is Amount Verified',
  registerReconciliation_AmountDifference: 'Amount Difference',
  registerReconciliation_LogReconciliation: 'Log Reconciliation',
  // ticket modification setting
  ticketModificationSetting_Title: 'Ticket modification setting',
  ticketModificationSetting_TicketCondition: 'Ticket condition',
  ticketModificationSetting_AllowToModifyTicket: 'Allow modify ticket',
  ticketModificationSetting_IsPercentageBase: 'Is Percentage Base',
  ticketModificationSetting_Amount: 'Amount',
  ticketModificationSetting_Create: 'Create new setting',
  ticketModificationSetting_Update: 'Update',
  // cancellationPolicyPage
  cancellationPolicyPage_Title: 'Cancellation policies',
  cancellationPolicyPage_TicketCondition: 'Ticket condition',
  cancellationPolicyPage_IsPercentageBase: 'Is percentage base',
  cancellationPolicyPage_CheckinTime: 'Checkin time',
  cancellationPolicyPage_Plans: 'Plans',
  cancellationPolicyPage_Hours: 'Hours',
  cancellationPolicyPage_Amount: 'Amount',
  cancellationPolicyPage_Create: 'Create',
  cancellationPolicyPage_Update: 'Update',
  cancellationPolicyPage_DuplicateHoursError: 'Duplicate hours',
  // pdf templates
  pdfTemplatesPage_Title: 'Pdf Templates',
  pdfTemplatesPage_Name: 'Name',
  pdfTemplatesPage_CultureCode: 'Culture code',
  pdfTemplatesPage_Content: 'Content',
  pdfTemplatesPage_CreatePdfTemplate: 'Create pdf template',
  pdfTemplatesPage_UpdatePdfTemplate: 'Update pdf template',
  // bookings
  bookingPage_Title: 'Manage booking',
  bookingPage_NoOfPassenger: 'No. Passenger',
  bookingPage_DepartureDate: 'Departure date',
  bookingPage_ArrivalDateTime: 'Arrival date',
  bookingPage_TicketConditions: 'Ticket conditions',
  bookingPage_TicketClasses: 'Ticket classes',
  bookingPage_ReceiptRefNo: 'Receipt No',
  bookingPage_PassengerName: 'Passenger name',
  bookingPage_ViewTickets: 'View tickets',
  bookingPage_DownloadPdf: 'Download pdf',
  bookingPage_PrintTicket: 'Print ticket',
  bookingPage_Tickets: 'Tickets',
  bookingPage_Comments: 'Comments',
  bookingPage_ChangeDate: 'Change date',
  bookingPage_ChangeValues: 'Change values',
  bookingPage_BookingHistory: 'Booking history',
  bookingPage_TripHistory: 'Trip history',
  bookingPage_HasBaggage: 'Has baggage',
  // ticket conflict
  ticketConflictPage_Title: 'Ticket conflict management',
  ticketConflictPage_TripCode: 'Trip code',
  ticketConflictPage_ConflictReason: 'Conflict reason',
  ticketConflictPage_ChangeSeat: 'Change seat',
  ticketConflictPage_ChangeTrip: 'Modify trip',
  ticketConflictPage_CancelTicket: 'Cancel ticket',
  ticketConflictPage_TicketRefNo: 'Ticket ref no',
  ticketConflictPage_TripAmount: 'Trip amount',
  ticketConflictPage_TicketAmount: 'Ticket amount',
  ticketConflictPage_SeatingModelName: 'Seating Model',

  // companyRolesPage

  companyRolesPage_Title: 'Roles',
  companyRolesPage_RoleName: 'Role Name',
  companyRolesPage_Permissions: 'Permissions',
  companyRolesPage_NormalizedName: 'Normalized Name',
  companyRolesPage_IsAdminRole: 'Is Admin Role',
  companyRolesPage_IsTransportRole: 'Is Transport Role',
  companyRolesPage_IsPOSRole: 'Is POS Role',
  companyRolesPage_AddNewRole: 'Add new role',
  companyRolesPage_UpdateRole: 'Update role',

  // BaggageReconciliation page

  baggageReconciliation_Title: 'Baggage Reconciliations',
  baggageReconciliation__SelectCheckInUser: 'Select check-in user',
  baggageReconciliation__TripName: 'Trip name',
  baggageReconciliation__BookingDate: 'Booking date',

  // shipment management
  shipmentManagementPage_Title: 'Shipment management',
  shipmentManagementPage_ShipmentTariffs: 'Shipment tariffs',
  shipmentManagementPage_BoxCategory: 'Box category',
  shipmentManagementPage_CreateBoxCategory: 'Create box category',
  shipmentManagementPage_UpdateBoxCategory: 'Update box category',
  shipmentManagementPage_BoxType: 'Box type',
  shipmentManagementPage_CreateBoxType: 'Create box type',
  shipmentManagementPage_UpdateBoxType: 'Update box type',
  shipmentManagementPage_BoxVolume: 'Box volume',
  shipmentManagementPage_CreateBoxVolume: 'Create box volume',
  shipmentManagementPage_UpdateBoxVolume: 'Update box volume',
  shipmentManagementPage_BoxWeight: 'Box weight',
  shipmentManagementPage_CreateBoxWeight: 'Create box weight',
  shipmentManagementPage_UpdateBoxWeight: 'Update box weight',
  shipmentManagementPage_TariffAmount: 'Tariff Amount',
  shipmentManagementPage_CreateTariffAmount: 'Create tariff amount',
  shipmentManagementPage_UpdateTariffAmount: 'Update Tariff Amount',
  shipmentManagementPage_CancellationPolicy: 'Cancellation policy',
  shipmentManagementPage_UpdateCancellationPolicy: 'Update cancellation policy',
  shipmentManagementPage_BeforeAssignTripAmount: 'Before assign trip amount',
  shipmentManagementPage_IsPercentageBase: 'Is percentage base',
  // terminals (P35)
  terminalsPage_Title: "Terminals",
  terminalsPage_Intro: "A terminal is a physical device (Sunmi T2, T2s, V3 MIX…) attached to a station or a vehicle. It is enrolled once with a single-use code, then used by several agents.",
  terminalsPage_Create: "Create a terminal",
  terminalsPage_CreateOk: "Create and get the code",
  terminalsPage_Name: "Name",
  terminalsPage_NamePlaceholder: "e.g. Ouaga counter – T2s",
  terminalsPage_Scope: "Scope",
  terminalsPage_Station: "Station",
  terminalsPage_Vehicle: "Vehicle",
  terminalsPage_Status: "Status",
  terminalsPage_Status_PendingEnrollment: "Pending enrollment",
  terminalsPage_Status_Active: "Active",
  terminalsPage_Status_Revoked: "Revoked",
  terminalsPage_Status_Retired: "Retired",
  terminalsPage_Retire: "Retire",
  terminalsPage_Retired: "Terminal retired.",
  terminalsPage_RetireTitle: "Retire terminal {{name}}",
  terminalsPage_RetireWarning: "The terminal will no longer receive a certificate and cannot be enrolled again. Tickets it already sold remain valid. If it is lost or stolen, revoke it instead.",
  terminalsPage_RetireReason: "Reason (optional)",
  terminalsPage_StatusDetail: "Date, author and reason",
  terminalsPage_DeviceModel: "Device model",
  terminalsPage_LastSeen: "Last used",
  terminalsPage_LastAgent: "Last agent",
  terminalsPage_Actions: "Actions",
  terminalsPage_NewCode: "New code",
  terminalsPage_NewCodeConfirmTitle: "New enrollment code for « {{name}} »?",
  terminalsPage_NewCodeConfirmContent: "Use it to reinstall or replace the device. The current installation stops working until the new code is entered.",
  terminalsPage_Revoke: "Revoke",
  terminalsPage_RevokeTitle: "Revoke « {{name}} »?",
  terminalsPage_RevokeWarning: "Final: the device can no longer open a session and its certificates are revoked (lost or stolen terminal).",
  terminalsPage_RevokeReason: "Reason",
  terminalsPage_Revoked: "Terminal revoked",
  terminalsPage_CodeTitle: "Enrollment code for « {{name}} »",
  terminalsPage_CodeOnce: "This code is shown only once: copy it now.",
  terminalsPage_CodeValidity: "Valid for 24 hours (until {{date}}), single use.",
  terminalsPage_CodeHowTo: "On the terminal, after the agent signs in: Settings › Terminal, enter the code, then « Enroll this terminal ».",
  terminalsPage_CodeDone: "I have copied the code",
  terminalsPage_Error: "The operation failed",
  TerminalNotFound: "Terminal not found",
  TerminalRevoked: "This terminal is revoked",
  InvalidLanguage: "Unknown language (French or English expected)",
  TerminalNameRequired: "Terminal name required",
  TerminalScopeInvalid: "Station or vehicle not found in your company",
};
export default companyEnPages;
